import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './polyfills';

import './sass/styles/font.scss';
import './sass/styles/global.scss';

import { HashRouter } from 'react-router-dom';
// TODO: check why the provider is wrapped into the store class
import Store from 'components/Store';
import LayoutRouter from 'layout/LayoutRouter';



function prepareReactApp(){
    startReactApp();
}

function startReactApp(){
    ReactDOM.render(
        <>
            <Store>
                <HashRouter>
                    <LayoutRouter />
                </HashRouter>
            </Store>
        </>,
        document.getElementById('root') as HTMLElement
    )
};

prepareReactApp();
